/*!
 * 
 * 
 * Date: 2023-10-12T17:08Z
 * Copyright (c) <2023> <GTS Teclecom Service Private Limited>
 * Author : Ravi Jangra
 */
export function reorderList(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  }
  